import styled from "styled-components";
import Button from "../Button";
import StepBody from "./StepBody";
import StepHeader from "./StepHeader";
import {ConfigurateurContext} from "../../context/context";
import {
    areDimensionsConstraintValidated,
    areDimensionsFilled,
    computeWeightDecoupe, getOptionChantsLabel,
    getSizeLabel, getThicknessValue
} from "../../helper/function";
import axios from "axios";
import {
    DECOUPE_FORMS,
    DECOUPE_FORMS_BOIS_ONLY,
    DECOUPE_FORMS_BOIS_PLEXI_MV, DECOUPE_FORMS_MV_ONLY,
    MATERIAL_SHADES,
    PLIAGE_FORMS
} from "../../helper/materials";
import {device, TYPE_DECOUPE, TYPE_PLIAGE} from "../../helper/constants";
import { getMaterialAndShadeFromCurrentPath } from "../../helper/function";
import LoadingSpinner from "../LoadingSpiner";

const {
    element: {
        useState,
        useEffect,
    },
} = wp;
const Wrapper = styled.div`
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    background-color: white;
`;

const StepButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 20px;
  gap: 20px;
  margin-bottom: 0;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  position: relative;
  z-index: 999;
  @media ${device.mobile} {
    padding: 20px;
    background: #144344;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;  
  }
`;
export default function Configurateur({mid, mode}) {

    const [currentStep, setCurrentStep] = useState(1);
    const [currentMaterial, setCurrentMaterial] = useState(null);
    const [currentShade, setCurrentShade] = useState(null);
    const [type, setType] = useState(null);
    const [thickness, setThickness] = useState(null);
    const [form, setForm] = useState(null);
    const [dimensions, setDimensions] = useState(null);
    const [option, setOption] = useState([]);
    const [quantity, setQuantity] = useState(1);
    const [price, setPrice] = useState(0);
    const [basePrice, setBasePrice] = useState(0);
    const [transportPrice, setTransportPrice] = useState(0);
    const [minStepBack, setMinStepBack] = useState(1); // Step that can go back
    const [canAddToCart, setCanAddToCart] = useState(true);
    const [addingToCart, setAddingToCart] = useState(false);
    const [isFromUrl, setIsFromUrl] = useState(false);

    const goNext = () => {
        // Mixpanel
        if (currentStep === 1) {
            mixpanel.track('configurateur-choix-materiaux' , {
                'materiau': currentMaterial,
            });
            console.log('track ' + currentMaterial);
        }
        if (currentStep === 2) {
            console.log('track ' + currentShade);
            mixpanel.track('configurateur-choix-nuance' , {
                'nuance': currentShade
            })

        }
        if (currentStep === 3) {
            console.log('track ' + type);
            mixpanel.track('configurateur-choix-action' , {
                'action': type
            })
        }
        if (currentStep === 4) {
            console.log('track ' + thickness);
            mixpanel.track('configurateur-choix-epaisseur' , {
                'épaisseur': thickness
            })
        }
        if (currentStep === 5) {
            console.log('track ' + form);
            mixpanel.track('configurateur-choix-forme' , {
                'forme': form
            })
        }
        if (currentStep === 6) {
            console.log('track contraintes');
            mixpanel.track('configurateur-saisie-contraintes' , {})
        }
        if (currentStep === 7) {
            setQuantity(1);
        }
        // End mixpanel
        if (
            currentStep === 2 &&
            (currentMaterial === 'melamine'
            || currentMaterial === 'bois-brut'
            || currentMaterial === 'plexi-pmma'
            || currentMaterial === 'plexi-polycarbonate'
            || currentMaterial === 'verre'
            || currentMaterial === 'miroir')
        ) {
            setCurrentStep(currentStep + 2);
            setType(TYPE_DECOUPE);
        } else {
            setCurrentStep(currentStep + 1);
        }
    }

    const canGoNext = () => {
        if (currentStep === 1 && currentMaterial !== null) {
            return true;
        }
        if (currentStep === 2 && currentShade !== null) {
            return true;
        }
        if (currentStep === 3 && type !== null) {
            return true;
        }
        if (currentStep === 4 && thickness !== null) {
            return true;
        }
        if (currentStep === 5 && form !== null) {
            return true;
        }
        if (currentStep === 6 && dimensions !== null && areDimensionsFilled(form, dimensions)) {
            if (areDimensionsConstraintValidated(currentShade, form, dimensions, thickness, type)) {
                return true;
            }
        }
        return false;
    }

    const goBack = () =>  {
        if (currentStep === 7) {
            setQuantity(1);
        }
        if (currentStep === 6) {
            setDimensions(null);
            setOption([]);
            setBasePrice(0);
            setTransportPrice(0);
        }
        if (currentStep === 5) {
            setForm(null);
        }
        if (currentStep === 4) {
            setThickness(null);
        }
        if (currentStep === 3) {
            setType(null);
        }
        if (currentStep === 2) {
            setCurrentShade(null);
        }
        if (
            currentStep === 4 &&
            (currentMaterial === 'melamine'
                || currentMaterial === 'bois-brut'
                || currentMaterial === 'plexi-pmma'
                || currentMaterial === 'plexi-polycarbonate'
                || currentMaterial === 'verre'
                || currentMaterial === 'miroir')
        ) {
            setCurrentStep(currentStep - 2);
        } else {
            setCurrentStep(currentStep - 1);
        }
        setCanAddToCart(true);
    }

    const reset = () => {
        window.location.href = "/";
    }

    const addToCart = () => {
        setAddingToCart(true);

        const params = new FormData();
        params.append('action', 'hjt_add_to_cart');
        params.append('quantity', quantity);
        params.append('shade', currentShade);
        params.append('mode', "form");
        params.append('thickness', getThicknessValue(thickness) + " mm");
        params.append('shadeimage', MATERIAL_SHADES[currentMaterial][currentShade]['image']);

        const sizeLabel = getSizeLabel(dimensions, form);
        params.append('sizelabel', sizeLabel);

        const optionLabel = getOptionChantsLabel(option);
        params.append('optionlabel', optionLabel);

        const unitPrice = price / quantity;
        params.append('hjtp', unitPrice);
        params.append('hjtp_trsp', transportPrice);
        params.append('hjtp_bp', basePrice);

        const unitWeight = computeWeightDecoupe(dimensions, currentShade, thickness);
        params.append('weight', unitWeight);

        if (type === TYPE_DECOUPE) {
            let formsData = null;
            if (DECOUPE_FORMS[form]) {
                formsData = DECOUPE_FORMS;
            }
            if (DECOUPE_FORMS_BOIS_PLEXI_MV[form]) {
                formsData = DECOUPE_FORMS_BOIS_PLEXI_MV;
            }
            if (DECOUPE_FORMS_BOIS_ONLY[form]) {
                formsData = DECOUPE_FORMS_BOIS_ONLY;
            }
            if (DECOUPE_FORMS_MV_ONLY[form]) {
                formsData = DECOUPE_FORMS_MV_ONLY;
            }
            params.append('formimage', formsData[form]['image']);
            params.append('iconDetail', currentMaterial === 'melamine' ? formsData[form]['iconDetailOption'] :formsData[form]['iconDetail']);
            params.append('form', formsData[form]['label']);
        }
        if (type === TYPE_PLIAGE) {
            params.append('formimage', PLIAGE_FORMS[form]['image']);
            params.append('iconDetail', PLIAGE_FORMS[form]['iconDetail']);
            params.append('form', PLIAGE_FORMS[form]['label']);
        }

        params.append('permalink', MATERIAL_SHADES[currentMaterial][currentShade]['permalink']);

        mixpanel.track('configurateur-ajout-panier' , {});

        axios.post("/wp-admin/admin-ajax.php", params).then(function(response){
            setTimeout(function() {
                window.location.href = "/panier";
            },300);

        });
    }

    useEffect(() => {
        const currentPath = window.location.pathname;
        if (currentPath.length > 1) {
            const { materiel, shade } = getMaterialAndShadeFromCurrentPath(currentPath);

            if (
                materiel === 'acier'
                || materiel === 'inox'
                || materiel === 'aluminium'
                || materiel === 'laiton'
                || materiel === 'bois-brut'
                || materiel === 'melamine'
                || materiel === 'plexi-pmma'
                || materiel === 'plexi-polycarbonate'
                || materiel === 'miroir'
                || materiel === 'verre'
            ) {
                setCurrentMaterial(materiel);
                setCurrentShade(shade);
                setCurrentStep(2);
                setMinStepBack(2);
            }

        }
    }, []);

    return(
        <Wrapper className={mode === 'modal' ? 'hjt-modal' : ''}>
            <StepHeader step={currentStep} isFromUrl={isFromUrl} goBackHandler={goBack} minStepBack={minStepBack}  />

            <ConfigurateurContext.Provider value={{
                currentStep,
                setCurrentStep,
                currentMaterial,
                setCurrentMaterial,
                currentShade,
                setCurrentShade,
                type,
                setType,
                thickness,
                setThickness,
                form,
                setForm,
                dimensions,
                setDimensions,
                quantity,
                setQuantity,
                price,
                setPrice,
                setBasePrice,
                setTransportPrice,
                option,
                setOption,
                canAddToCart,
                setCanAddToCart
            }}>
                <StepBody handleSelect={goNext} mode={mode} />
            </ConfigurateurContext.Provider>


            <StepButtons>
                { isFromUrl && currentStep === 3 &&
                    <Button
                        handleClick={reset}
                    >
                        Découper une autre pièce
                    </Button>
                }
                {currentStep < 7 && (
                    <Button
                        handleClick={goNext}
                        icon={"/wp-content/uploads/2023/09/icon-arr-right.png"}
                        iconPosition={"right"}
                        disabled={!canGoNext()}
                    >
                        Suivant
                    </Button>
                )}
                {currentStep === 7 && price !== 0 && quantity >= 1 && (
                    <Button
                        handleClick={addToCart}
                        //disabled={addingToCart || !canAddToCart}
                        disabled={true}
                        variation="btn-green"
                    >
                        {addingToCart ? <LoadingSpinner /> : 'Ajouter au panier'}

                    </Button>
                )}
            </StepButtons>
        </Wrapper>
    );
}